import React, { Component } from "react";
import axios from "axios";
import styles from "./styles/InviteTalent.scss";
import BackToDashboard from './BackToDashboard';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";


export default class InviteTalent extends Component {
  constructor(props) {
    super(props);
    let cd = new Date();
    this.state = {
      wordCount: 300,
      error_saving: false,
      saved_recently: false,
      saving: false,
      errorMsg: undefined,
      nominee: {
        first_name: undefined,
        last_name: undefined,
        email: undefined,
        description: undefined,
        job_applied: undefined,
        reference: undefined,
        nominator: sessionStorage.getItem("employer"),
        nomination_date:
          cd.getFullYear() + "-" +
          ((cd.getMonth()+1 <= 9) ? ("0" + (cd.getMonth()+1)) : (cd.getMonth()+1)) + "-" +
          ((cd.getDate() <= 9) ? ("0" + cd.getDate() ): cd.getDate() ),
        archive: false,
        auth_invite: true
      }
    };
  }

  handleDataChange = (e) => {
    this.setState({
      error_saving: false,
      saved_recently: false,
      nominee: {
        ...this.state.nominee,
        [e.target.id]: e.target.value
      }
    })
  }

  handleChange = e => {
    let target = e.target;
    this.setState({
      errorMsg: undefined,
      [target.id]: !this.state[target.id]
    });
  }

  handleTextArea = (e) => {
    let target = e.target;
    this.setState({
      wordCount: 300 - target.value.length,
      nominee: {
        ...this.state.nominee,
        description: e.target.value
      }
    })
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ saving: true })
    axios
      .post("/api/kingstonconnect/addnominee/", this.state.nominee)
      .then(res => {
        document.getElementById("talent-invite").reset()
        this.setState({
          error_saving: false,
          saved_recently: true,
          saving: false,
          nominee: {
            ...this.state.nominee,
            first_name: undefined,
            last_name: undefined,
            email: undefined,
            job_applied: undefined,
            description: "",
          }
        }, () => this.redirect())
        return Promise.resolve(1);
      })
      .catch(e => {
        this.setState({ error_saving: true, saved_recently: false })
        console.log(e)
      });
  }

  redirect = () => {
    setTimeout(() => {
      window.location.href = "/kingstonconnect/thankyou/invite"
    }, 500)
  }


  render() {
    return (
      <div className={styles.page}>
        <h1>Invite Talent to <strong><span style={{color: '#007D99'}}>Kingston</span>Connect</strong></h1>
        <h3>Refer an individual who you think would be an excellent addition to Kingston’s workforce.</h3>
        <BackToDashboard />
        <form className={styles.form} onSubmit={this.submitForm} id="talent-invite">
        <div className="row">
          <div className="form-group col-6">
            <label>First Name</label>
            <input onChange={this.handleDataChange} value={this.state.nominee.first_name} id="first_name" required className="form-control" />
          </div>
          <div className="form-group col-6">
            <label>Last Name</label>
            <input onChange={this.handleDataChange} value={this.state.nominee.last_name} id="last_name" required className="form-control" />
          </div>
          </div>
          <div className="form-group">
            <label>Email Address</label>
            <small className="form-text text-muted">We will send an email to this address so the nominee can accept their invitation.</small>
            <input onChange={this.handleDataChange} value={this.state.nominee.email} id="email" required type="email" className="form-control" aria-describedby="emailHelp" />
          </div>
          <div className="form-group">
            <label>Job Title</label>
            <small className="form-text text-muted">If you interviewed the nominee, please identify which job they applied for in your organization</small>
            <input onChange={this.handleDataChange} value={this.state.nominee.job_applied} id="job_applied" className="form-control" />
          </div>
          <label> I know this individual through </label> <br/>
          <div style={{textAlign: 'left', "marginBottom": "8px"}}>
            <label>
              <input name="reference" id="reference" onChange={this.handleChange} required type="radio" value="a previous interview"/> 1) a previous interview
            </label>
            <br/>
            <label>
              <input name="reference" id="reference" onChange={this.handleChange} required type="radio" value="a previous or current mentorship"/> 2) a previous or current mentorship
            </label>
            <br/>
            <label>
              <input name="reference" id="reference" onChange={this.handleChange} required type="radio" value="a previous or current internship"/> 3) a previous or current internship
            </label>
            <br/>
            <label>
              <input name="reference" id="reference" onChange={this.handleChange} required type="radio" value="previous employment"/> 4) previous employment
            </label>
            <br/>
            <label>
              <input name="reference" id="reference" onChange={this.handleChange} required type="radio"/> 5) Other: {" "}
              <input type="text" id="reference" onChange={this.handleChange} className="form-control" />
            </label>
          </div>
          <div className="form-check px-0 text-left">
            <input className="form-check-input" required type="checkbox" value="" id="defaultCheck1"/>
            <label className="form-check-label" style={{"marginBottom": "8px"}} htmlFor="defaultCheck1">
              I certify that I have relevant credentials to be nominating this individual.
            </label>
          </div>
          <div className="form-check px-0 text-left">
            <input className="form-check-input" required type="checkbox" value="" id="defaultCheck2"/>
            <label className="form-check-label" style={{"marginBottom": "8px"}} htmlFor="defaultCheck2">
              I certify that I am nominating this individual through my experience with them in a professional capacity.
            </label>
          </div>
          <div className="form-group mt-3">
            <label>Please briefly describe why you are nominating this individual (Optional)</label>
            <textarea onChange={this.handleTextArea} className="form-control" value={this.state.nominee.description} id="nominee_description" maxLength={300} rows="4"></textarea>
            <small> Word Limit: {this.state.wordCount} </small>
          </div>
          <div className="form-check px-0 text-left">
            <input className="form-check-input" required type="checkbox" value="" id="defaultCheck2"/>
            <label className="form-check-label" style={{"marginBottom": "8px"}} htmlFor="defaultCheck2">
              I am willing to act as a reference for this nominee (optional)
            </label>
          </div>
            {
              this.state.errorMsg &&
              <div className="alert alert-danger" role="alert">
                <strong>Uh oh!</strong> {this.state.errorMsg}
              </div>
            }
          <button type="submit" className="btn btn-primary" style={{"margin": "1%"}}>
            {"Submit "}
            {this.state.saving &&
              <FontAwesomeIcon spin
              icon={faSpinner}
              />
          }
          </button>
          {this.state.saved_recently &&
            <div className="alert alert-success" role="alert">
              <strong>Sent!</strong> Your invitation has been sent.
            </div>
          }
          {this.state.error_saving &&
            <div className="alert alert-danger" role="alert">
              <strong>Uh oh!</strong> Change a few things up and try submitting again.
            </div>
          }
        </form>
      </div>
  )};
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/InviteTalent.js